'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagTgAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.01464e-05 0C9.33334 0 18.6667 -4.57762e-05 28 4.85778e-06V20C18.6666 20 9.33329 20 -6.10352e-05 20C0.000366759 13.3333 -0.000156474 6.66667 2.01464e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.01464e-05 0L28 4.85778e-06V20H-6.10352e-05L2.01464e-05 0Z",
          fill: "#FFD44D"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M12 0L28 4.85778e-06V4H12V0Z", fill: "#159A74" }),
      /* @__PURE__ */ jsx("path", { d: "M12 8H28V12H12V8Z", fill: "#159A74" }),
      /* @__PURE__ */ jsx("path", { d: "M28 16H-3.57628e-06L-6.10352e-05 20H28V16Z", fill: "#159A74" }),
      /* @__PURE__ */ jsx("path", { d: "M2.01464e-05 0H12V12H-3.57628e-06L2.01464e-05 0Z", fill: "#ED1F45" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6 7.56L3.64885 9.23607L4.51635 6.48207L2.19577 4.76393L5.08305 4.73793L6 2L6.91694 4.73793L9.80422 4.76393L7.48364 6.48207L8.35114 9.23607L6 7.56Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpFlagTgAsset = forwardRef(FlagTgAsset);

export { VpFlagTgAsset as default };
